import Bugsnag from "@bugsnag/js";
import { UserData } from "../stores/account-store/account-store.model";
import { CoverageArea } from "../stores/coverage-area-store/coverage-area-store.model";
import { COVERAGE_AREA_DATA_KEY, USER_DATA_KEY } from "./constants";
import { load } from "./storage";

type EventAnalytic = {
  sellerUsername: string; // seller username
  eventName: string;
  eventCategory: string;
  eventLabel: string;
  eventValue?: any;
  trxId?: string;
  moengageContextId?: string;
  trackers: Array<"GTM" | "AF" | "ME">;
};

export const trackEvents = async ({
  sellerUsername,
  eventName,
  eventCategory,
  eventLabel,
  eventValue,
  trxId,
  trackers,
}: EventAnalytic) => {
  const savedUser: UserData = await load(USER_DATA_KEY);
  const savedCoverageArea: CoverageArea = await load(
    `${COVERAGE_AREA_DATA_KEY}-${sellerUsername}`
  );

  if (process && process.env.NODE_ENV === "development") {
    console.log(eventName);
  }

  // Google Analytics
  if (trackers.includes("GTM")) {
    if (typeof window.gtag !== "undefined") {
      try {
        if (savedUser?.id) {
          window.gtag("config", process.env.NEXT_PUBLIC_G_TRACKING_ID, {
            userId: savedUser?.id,
          });
        }
        if (savedUser?.id && savedCoverageArea?.id) {
          window.gtag("set", "user_properties", {
            coverage_area_id: savedCoverageArea?.id,
            cm_user_id: savedUser?.id,
            ...(trxId && { transaction_id: trxId }),
          });
        }
        window.gtag("event", eventName, {
          event_category: eventCategory,
          event_label: eventLabel,
          value: eventValue,
        });
      } catch (e) {
        Bugsnag.notify(e);
      }
    }
  }

  // AppsFlyer
  if (trackers.includes("AF")) {
    // Appsflyer already merged / integrated with GTM
  }

  // MoEngage
  if (trackers.includes("ME")) {
    try {
      window?.webEventHandler?.postMessage(
        "moengage-event-" + eventName + (trxId ? "-" + trxId : "")
      );
    } catch (e) {
      Bugsnag.notify(e);
    }
  }
};
